import { NgModule } from '@angular/core';
import { RouterModule } from "@angular/router";
import { authRoutes } from "./auth-routing";
import { NotFound404Module } from 'projects/lib-shared-core/src/public-api';
import { PublicLayoutModule } from '../layout/public/public-layout.module';

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forChild(authRoutes),
		NotFound404Module,
		PublicLayoutModule,
	],
})
export class SvcAuthModule { }
